import React, { Component } from 'react';

export default class Photovoltaik extends Component {

  componentDidMount() {
    try {
      window.galleryPV();
      window.adjustSubmenu();
    }
    catch (err) {
      console.log(err);
    }
  }

  render() {
    return (
      <div id="content" className="container" role="main">
        <div id="Planung u. Angebot" className="block row" data-nested="not-nested" data-containerid="" data-containercssclass="">
            <div className="col col-md-12">
              <respond-html id="html-1" description="HTML"><a name="unser-service"></a>
                <div className="section">
                  <div className="services">
                    <div className="row">
                      <div className="col-lg-12 text-center">
                        <h1 className="section-heading">Planung Ihrer Photovoltaikanlage</h1>
                        <p>Sie interssieren sich für eine Photovoltaikanlage mit Speicher? In 3 Schritten zu Ihrer individuellen Planung:</p>
                      </div>
                    </div>
                    <div className="row text-center">
                      <div className="col-md-4">
                        <span className="fa-stack fa-3x">
                          <i className="fa fa-circle fa-stack-2x text-primary"></i>
                          <i className="fa fa-file-signature fa-5 fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 className="service-heading">1. Planung anfordern</h4>
                        <p className="text-muted">Wir möchten Sie gerne umfassend fachlich beraten und benötigen noch weitere Details. Beantworten Sie hierzu unverbindlich unsere Fragen zu Ihrer aktuellen Situation und Anforderungen.
                          Unser Formular finden Sie über den folgenden <a href="http://planung.photovoltaik.pailer.com" target="blank">Link</a>: 
                          <p></p>
                          <a href="http://planung.photovoltaik.pailer.com" target="blank">
                            <button type="button" class="btn btn-primary btn-sm">Zum Formular</button>
                          </a>
                          <p></p>
                          </p>
                      </div>
                      <div className="col-md-4">
                        <span className="fa-stack fa-3x">
                          <i className="fa fa-circle fa-stack-2x text-primary"></i>
                          <i className="fa fa-search fa-5 fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 className="service-heading">2. Prüfung Ihrer Daten</h4>
                        <p className="text-muted">Wie geht es für Sie weiter? Nun sind wir dran! Im nächsten Schritt prüfen wir Ihre Daten. Aufgrund der aktuell hohen Nachfrage kommt es vereinzelt zu längeren Bearbeitungszeiten.</p>
                      </div>
                      <div className="col-md-4">
                        <span className="fa-stack fa-3x">
                          <i className="fa fa-circle fa-stack-2x text-primary"></i>
                          <i className="fa fa-calendar fa-5 fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 className="service-heading">3. Termin und Beratung</h4>
                        <p className="text-muted">Nach der Prüfung wird die Planung konkreter. Wir klären weitere Details telefonisch, per email oder vereinbaren einen Termin vor Ort. Anschließend startet die individuelle Angebotserstellung.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </respond-html>
            </div>
          </div>
        <div id="Unser Service" className="block row  bg-light-gray" data-nested="not-nested" data-containerid="" data-containercssclass="">
          <div
            className="col col-md-12">
            <respond-html id="html-1" description="HTML"><a name="unser-service"></a>
              <div className="section">
                <div className="services">
                  <div className="row">
                    <div className="col-lg-12 text-center">
                      <h1 className="section-heading">UNSER SERVICE</h1>
                      <hr></hr>
                    </div>
                  </div>
                  <div className="row text-center">
                    <div className="col-md-6">
                      <span className="fa-stack fa-3x">
                        <i className="fa fa-circle fa-stack-2x text-primary"></i>
                        <i className="fa fa-pencil fa-5 fa-stack-1x fa-inverse"></i>
                      </span>
                      <h4 className="service-heading">Individuelle Planung und Beratung</h4>
                      <p className="text-muted">...</p>
                    </div>
                    <div className="col-md-6">
                      <span className="fa-stack fa-3x">
                        <i className="fa fa-circle fa-stack-2x text-primary"></i>
                        <i className="fa fa-check fa-5 fa-stack-1x fa-inverse"></i>
                      </span>
                      <h4 className="service-heading">Installation, Anmeldung und Inbetriebnahme</h4>
                      <p className="text-muted">...</p>
                    </div>
                  </div>
                </div>
              </div>
            </respond-html>
          </div>
        </div>
        <div id="hersteller banner" className="block row" data-nested="not-nested" data-containerid="" data-containercssclass="">
          <div className="col col-md-12">
            <respond-html id="html-4" description="HTML">
              <div className="hersteller-section">
                <div className="row">
                  <div className="col-md-12 text-center">
                    <a href="http://www.vaillant.com" target="blank">
                      <img alt="Vaillant Heizung" className="hersteller" src="files/photovoltaik/hersteller/vaillant.png" />
                    </a>
                    <a href="https://www.solaredge.com/de/" target="blank">
                      <img className="hersteller" src="files/photovoltaik/hersteller/solaredge.jpeg" />
                    </a>
                  </div>
                </div>
              </div>
            </respond-html>
          </div>
        </div>
        <div id="SolarEdge" className="block row bg-light-gray" data-nested="not-nested" data-containerid="" data-containercssclass="">
          <div className="col col-md-12">
            <respond-html id="html-2" description="HTML">
              <a id="SolarEdge" name="SolarEdge"></a>
              <div className="section">
                <div className="row">
                  <div className="col-md-12">
                    <div className="text-center">
                      <h1>Das smarte SolarEdge PV System</h1>
                      <hr className="gray"></hr>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="same-height shadowbox-white shadow-border-top">
                    <div className="row">
                      <div className="col-md-12 text-center">
                        <h4>mySolarEdge App</h4>
                      </div>
                      <div className="col-md-12">
                        <div id="gallery-mysolaredge" className="gallery" style={{ display: 'none' }}>
                          <img src="/files/photovoltaik/gallery-mysolaredge/thumbnail/1_mySolarEdge.jpg" data-image="/files/photovoltaik/gallery-mysolaredge/thumbnail/1_mySolarEdge.jpg" />
                          <img src="/files/photovoltaik/gallery-mysolaredge/thumbnail/2_mySolarEdge.jpg" data-image="/files/photovoltaik/gallery-mysolaredge/thumbnail/2_mySolarEdge.jpg" />
                          <img src="/files/photovoltaik/gallery-mysolaredge/thumbnail/3_mySolarEdge.jpg" data-image="/files/photovoltaik/gallery-mysolaredge/thumbnail/3_mySolarEdge.jpg" />
                          <img src="/files/photovoltaik/gallery-mysolaredge/thumbnail/4_mySolarEdge.jpg" data-image="/files/photovoltaik/gallery-mysolaredge/thumbnail/4_mySolarEdge.jpg" />
                          <img src="/files/photovoltaik/gallery-mysolaredge/thumbnail/5_mySolarEdge.jpg" data-image="/files/photovoltaik/gallery-mysolaredge/thumbnail/5_mySolarEdge.jpg" />
                          <img src="/files/photovoltaik/gallery-mysolaredge/thumbnail/6_mySolarEdge.jpg" data-image="/files/photovoltaik/gallery-mysolaredge/thumbnail/6_mySolarEdge.jpg" />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <h4>Überwachen Sie Ihre Energieproduktion und Ihren Energieverbrauch</h4>
                        <p>Mit mySolarEdge ist es einfach, den Überblick über Ihre Solarenergie zu behalten. Diese kostenlose, einfach zu bedienende App läuft auf Ihrem Smartphone und bietet Ihnen ein Echtzeit-Überblick Ihrer Energieleistung. Greifen Sie auf die Ergebnisse zu und planen Sie Ihre Energienutzung intelligent, um hohe Strompreise zu vermeiden und Ihre Rechnung niedrig zu halten.</p>
                        <p>Erfahren Sie mehr bei <a href='https://www.solaredge.com/de/products/pv-monitoring#/' target="blank">SolarEdge</a>.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="same-height shadowbox-white shadow-border-top">
                    <div className="row">
                      <div className="col-md-12 text-center">
                        <h4>Mehr erzeugen, mehr verbrauchen, mehr sparen</h4>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div id="optimierer-gallery" className="gallery" style={{ display: 'none' }}>
                          <div data-type="youtube" data-videoid="ChjyoppwpUw"></div>
                        </div>
                        <p className="text-muted">Verwandeln Sie Solarmodule in intelligente PV-Module</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <p>Verwandeln Sie Solarmodule in intelligente PV-Module – für maximale Leistung und Effizienz</p>
                        <p>Der Leistungsoptimierer von SolarEdge ist ein DC/DC Wandler, der vom Installateur an jedes PV-Modul angeschlossen wird – damit werden Sie zu intelligenten Modulen. Die SolarEdge Leistungsoptimierer steigern den Energieertrag von PV-Anlagen, indem der Punkt der maximalen Leistungsabgabe (MPPT) für jedes Modul einzeln gesucht wird. Dies kann zu höheren Einnahmen und einer kürzeren Amortisationszeit des Systems führen.</p>
                        <p>Details zu Leistungsoptimierung von <a href='https://www.solaredge.com/de/products/power-optimizers#/' target="blank">SolarEdge</a>.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="same-height shadowbox-white shadow-border-top">
                    <div className="row">
                      <div className="col-md-12 text-center">
                        <h4>Smart Energy Home</h4>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div id="smartmanager-gallery" className="gallery" style={{ display: 'none' }}>
                          <div data-type="youtube" data-videoid="BjtL_vIkyNg"></div>
                        </div>
                        <p className="text-muted">SolarEdge smart energy manager</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <p>Da der Wechselrichter bereits die Solarenergieproduktion überwacht und steuert, ist er ideal positioniert, um die Energiespeicherung und den Energieverbrauch zu steuern. Der Wechselrichter kann Solarenergie in einer Batterie speichern, um sie abends zu verwenden, zusätzliche PV-Energie zur Warmwasserbereitung umleiten oder tagsüber andere intelligente Geräte aktivieren, um die Stromrechnung zu senken. Durch die Steuerung der Energie auf eine umfassende Weise verwandelt der Wechselrichter intelligente Häuser in Smart Energy Häuser und legt die Macht in die Hände der Verbraucher.</p>
                        <p>Details zu Leistungsoptimierung von <a href='https://www.solaredge.com/de/products/device-control#/' target="blank">SolarEdge</a>.</p>                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </respond-html>
          </div>
        </div>
        <div id="Vaillant" className="block row" data-nested="not-nested" data-containerid="" data-containercssclass="">
          <div className="col col-md-12">
            <respond-html id="html-2" description="HTML">
              <a id="Vaillant" name="Vaillant"></a>
              <div className="section">
                <div className="row">
                  <div className="col-md-12">
                    <div className="text-center">
                      <h1>Vaillant auroPOWER</h1>
                      <hr className="gray"></hr>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="">
                    <div className="row">
                      <div className="col-md-4">
                        <div id="gallery-auropower" className="gallery" style={{ display: 'none' }}>
                          <img src="/files/photovoltaik/gallery-auropower/thumbnail/1_auropower.jpeg" data-image="/files/photovoltaik/gallery-auropower/thumbnail/1_auropower.jpeg" />
                          <img src="/files/photovoltaik/gallery-auropower/thumbnail/2_auropower.jpeg" data-image="/files/photovoltaik/gallery-auropower/thumbnail/2_auropower.jpeg" />
                          <img src="/files/photovoltaik/gallery-auropower/thumbnail/3_auropower.jpeg" data-image="/files/photovoltaik/gallery-auropower/thumbnail/3_auropower.jpeg" />
                          <img src="/files/photovoltaik/gallery-auropower/thumbnail/4_auropower.jpeg" data-image="/files/photovoltaik/gallery-auropower/thumbnail/4_auropower.jpeg" />
                        </div>
                      </div>
                      <div className="col-md-8">
                        <h4>Vaillant auroPOWER: Qualität "made in Germany"</h4>                                                
                        <p>Die hochwertig verarbeiteten Photovoltaikmodule auroPOWER von Vaillant liefern immer zuverlässig Energie – auch dann, wenn der Himmel mal wolkenverhangen ist. Sie werden in Deutschland produziert, überzeugen durch ihre langlebige Qualität und punkten mit 25 Jahren Produkt- und Leistungsgarantie. Die Module sind robust, wind- und wetterfest und fügen sich harmonisch in jede Dacharchitektur ein. Je nach Anforderung bietet Vaillant zwei verschiedene Produktlinien.
                        <p></p>
                          <ul>
                            <li>Für ein hervorragendes Preis-Leistungs-Verhältnis: 325 Wp Ausgangsleistung, Silberfarbener Rahmen mit weißer Folie und schwarzen Zellen</li>
                            <li>Für höchste Design-Ansprüche: 325 Wp Ausgangsleistung, Schwarzer Rahmen mit schwarzer Folie und schwarzen Zellen.</li>
                          </ul>                          
                          </p>
                        <p>Erfahren Sie mehr bei <a href='https://www.vaillant.de/heizung/produkte/auropower-das-vaillant-photovoltaik-system-6147.html' target="blank">Vaillant</a>.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </respond-html>
          </div>
        </div>        
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/photovoltaik/Photovoltaik Rework.js